import { useCallback, useEffect, useState } from 'react';

type Args = {
  autoStart?: boolean;
  duration: number;
  onEnd: () => void;
  onRestart?: () => void;
};

export function useCountdownTimer({ autoStart = false, duration, onEnd, onRestart }: Args) {
  const [startTime, setStartTime] = useState<number | null>(autoStart ? Date.now() : null);

  const startTimer = useCallback(() => {
    setStartTime(Date.now());
  }, []);

  const resetTimer = useCallback(() => {
    setStartTime(Date.now());
    onRestart?.();
  }, []);

  useEffect(() => {
    let timer: NodeJS.Timeout | null = null;

    if (startTime) {
      timer = setTimeout(() => {
        onEnd();
        setStartTime(Date.now());
      }, duration);
    }

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [startTime]);

  return {
    startTimer,
    resetTimer,
  };
}
